'use client';

import { useEffect, useState } from 'react';
import styles from './AccessControlFaq.module.css';

export interface AccessControlFaqItem {
  question: string;
  content: Array<{ paragraph?: string; items?: string[] }>;
}

export function AccessControlFaq({ items }: { items: AccessControlFaqItem[] }) {
  const [mobile, setMobile] = useState(false);
  const [open, setOpen] = useState<Set<number>>(() => new Set([0, 1]));

  useEffect(() => {
    const query = window.matchMedia('(max-width: 767px)');
    const update = () => {
      setMobile(query.matches);
      setOpen(query.matches ? new Set() : new Set([0, 1]));
    };
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  const toggle = (index: number) => {
    setOpen((current) => {
      if (current.has(index)) {
        const next = new Set(current);
        next.delete(index);
        return next;
      }
      return mobile ? new Set([index]) : new Set(current).add(index);
    });
  };

  return (
    <div className={styles.columns} id="ac-faq">
      {items.map((item, index) => (
        <details
          className={styles.item}
          key={item.question}
          open={open.has(index)}
          onToggle={(event) => {
            if (event.currentTarget.open !== open.has(index)) toggle(index);
          }}
        >
          <summary data-no-cms-button>{item.question}</summary>
          <div className={styles.body}>
            {item.content.map((part, partIndex) =>
              part.paragraph ? <p key={partIndex}>{part.paragraph}</p> : (
                <ul key={partIndex}>{part.items?.map((entry) => <li key={entry}>{entry}</li>)}</ul>
              )
            )}
          </div>
        </details>
      ))}
    </div>
  );
}
